import { render } from "./ScheduledSnapshots.vue?vue&type=template&id=f25c3a68&scoped=true"
import script from "./ScheduledSnapshots.vue?vue&type=script&lang=js"
export * from "./ScheduledSnapshots.vue?vue&type=script&lang=js"

import "./ScheduledSnapshots.vue?vue&type=style&index=0&id=f25c3a68&lang=less&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25c3a68"]])

export default __exports__